module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-9.feb22fb6.png";